module.exports = __webpack_public_path__ + "media/bootstrap-icons/hr-03db0ae5.svg";